<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="760px"
    top="6vh"
    class="pf-pc-dialog"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <template slot="title">
      <div class="pf-pc-title">
        <span class="pf-pc-title-text">不罚</span>
        <span class="pf-pc-subtitle">罚不是目的，罚是为了不罚。</span>
      </div>
    </template>

    <!-- 工具行 -->
    <div class="pf-pc-toolbar">
      <div class="pf-pc-switch-group">
        <span class="pf-pc-switch-label">只看罚站</span>
        <el-switch v-model="onlyPenalized"></el-switch>
      </div>
      <el-button size="small" icon="el-icon-trophy" class="pf-pc-exemplary-btn" @click="openExemplaryDialog">守纪标兵</el-button>
    </div>

    <!-- 罚站总表 -->
    <div class="pf-pc-table-card">
      <el-table
        ref="penaltyTable"
        class="pf-drag-scroll"
        :data="displayRows"
        v-loading="loading"
        size="mini"
        style="width: 100%"
        empty-text="暂无数据"
        :default-sort="{ prop: 'studentNumber', order: 'ascending' }"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="studentNumber" label="学号" sortable="custom" min-width="78"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="remainingDays" label="剩余天数" sortable="custom" min-width="102">
          <template slot-scope="scope">{{ scope.row.remainingDays > 0 ? scope.row.remainingDays : '-' }}</template>
        </el-table-column>
        <el-table-column prop="endDate" label="站完日期" sortable="custom" min-width="110">
          <template slot-scope="scope">{{ fmtDateFull(scope.row.endDate) }}</template>
        </el-table-column>
        <el-table-column prop="disciplineDays" label="守纪天数" sortable="custom" min-width="102">
          <template slot-scope="scope">{{ scope.row.disciplineDays != null ? scope.row.disciplineDays : '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="76">
          <template slot-scope="scope">
            <el-button type="text" size="mini" class="pf-pc-action-btn" @click="openDetailDialog(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 详情弹窗（只读，学生查看用） -->
    <el-dialog
      :title="(detailTarget.name || '') + '的罚站记录'"
      :visible.sync="detailDialogVisible"
      append-to-body
      width="680px"
      top="8vh"
      class="pf-pc-dialog"
    >
      <el-tabs v-model="detailTab" stretch>
        <el-tab-pane label="罚站记录" name="penalty">
          <el-table
            ref="detailPenaltyTable"
            :data="detailPenaltyRows"
            size="mini"
            class="pf-pc-detail-table"
            style="width: 100%"
            max-height="320"
            empty-text="暂无罚站记录"
            :default-sort="{ prop: 'punishDate', order: 'descending' }"
            :row-class-name="penaltyRowClass"
            @sort-change="handleDetailPenaltySort"
          >
            <el-table-column prop="punishDate" label="处罚时间" sortable="custom" min-width="172" show-overflow-tooltip>
              <template slot-scope="scope">{{ fmtDateFull(scope.row.punishDate) }} {{ scope.row.punishPeriod === 2 ? '下午' : '上午' }}</template>
            </el-table-column>
            <el-table-column prop="violationContent" label="违纪内容" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="days" label="登记天数" sortable="custom" min-width="128" show-overflow-tooltip>
              <template slot-scope="scope">{{ daysFormula(scope.row) }}</template>
            </el-table-column>
            <el-table-column prop="endDate" label="站完日期" sortable="custom" min-width="152" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.currentDays === 0 ? '已减完' : fmtDateFull(scope.row.endDate) }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="88" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="减罚记录" name="reduce">
          <el-table
            ref="detailReduceTable"
            :data="detailReduceRows"
            size="mini"
            class="pf-pc-detail-table"
            style="width: 100%"
            max-height="320"
            empty-text="暂无减罚记录"
            :default-sort="{ prop: 'createdAt', order: 'descending' }"
            @sort-change="handleDetailReduceSort"
          >
            <el-table-column prop="createdAt" label="登记时间" sortable="custom" min-width="152" show-overflow-tooltip>
              <template slot-scope="scope">{{ fmtDateFull(scope.row.createdAt) }}</template>
            </el-table-column>
            <el-table-column label="减罚对象" min-width="138" show-overflow-tooltip>
              <template slot-scope="scope">{{ recordLabel(scope.row.recordId) }}</template>
            </el-table-column>
            <el-table-column prop="reduceDays" label="减罚天数" sortable="custom" min-width="106" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="128" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.reason || '-' }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="pf-pc-footer">
        <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 守纪标兵弹窗 -->
    <el-dialog
      title="守纪标兵"
      :visible.sync="exemplaryDialogVisible"
      append-to-body
      width="480px"
      top="10vh"
      class="pf-pc-dialog"
    >
      <div class="pf-pc-exemplary-banner">
        <i class="el-icon-trophy pf-pc-banner-icon"></i>
        <div class="pf-pc-banner-title">本班守纪标兵</div>
        <div class="pf-pc-banner-text pf-pc-banner-left">从未罚站，始终如一</div>
        <div class="pf-pc-banner-text pf-pc-banner-right">——你们是全班最好的榜样！</div>
      </div>
      <div v-if="exemplaryRows.length" class="pf-pc-exemplary-list">
        <div v-for="r in exemplaryRows" :key="r.studentId" class="pf-pc-exemplary-row">
          <span class="pf-pc-exemplary-no">{{ r.studentNumber }}</span>
          <span class="pf-pc-exemplary-name">{{ r.name }}</span>
          <i class="el-icon-check pf-pc-exemplary-check"></i>
        </div>
      </div>
      <div v-else class="pf-pc-exemplary-empty">暂无守纪标兵，大家一起加油，从零罚站开始！</div>
      <div class="pf-pc-exemplary-footer">守纪是最高级的自律，为以上 {{ exemplaryRows.length }} 位同学点赞！</div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: 'PenaltyFreeDialog',
  props: {
    classId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      onlyPenalized: true,
      allRows: [],
      loading: false,
      semesterStart: null,
      lastSort: {
        field: 'studentNumber',
        order: 'ascending'
      },
      detailDialogVisible: false,
      detailTarget: {
        studentId: null,
        name: ''
      },
      detailTab: 'penalty',
      lastPenaltySort: {
        field: 'punishDate',
        order: 'descending'
      },
      lastReduceSort: {
        field: 'createdAt',
        order: 'descending'
      },
      detail: {
        penaltyRecords: [],
        reductions: []
      },
      exemplaryDialogVisible: false
    }
  },
  computed: {
    displayRows() {
      const base = this.onlyPenalized
        ? this.allRows.filter(r => r.remainingDays > 0)
        : this.allRows.slice()
      const { field, order } = this.lastSort
      const dir = order === 'descending' ? -1 : 1
      base.sort((a, b) => {
        let va = 0
        let vb = 0
        if (field === 'studentNumber') {
          va = Number(a.studentNumber) || 0
          vb = Number(b.studentNumber) || 0
        } else if (field === 'remainingDays') {
          va = a.remainingDays || 0
          vb = b.remainingDays || 0
        } else if (field === 'endDate') {
          va = a.endDate ? new Date(a.endDate).getTime() : 0
          vb = b.endDate ? new Date(b.endDate).getTime() : 0
        } else if (field === 'disciplineDays') {
          va = a.disciplineDays || 0
          vb = b.disciplineDays || 0
        }
        return (va - vb) * dir
      })
      return base
    },
    // 守纪标兵：从未被罚站过的学生（站完/减罚完都算被罚过），按学号升序
    exemplaryRows() {
      return this.allRows
        .filter(r => !r.hasPenaltyRecord)
        .slice()
        .sort((a, b) => (Number(a.studentNumber) || 0) - (Number(b.studentNumber) || 0))
    },
    detailPenaltyRows() {
      const rows = (this.detail.penaltyRecords || []).slice()
      const { field, order } = this.lastPenaltySort
      const dir = order === 'descending' ? -1 : 1
      rows.sort((a, b) => {
        let va = 0
        let vb = 0
        if (field === 'punishDate') {
          // 同一天按时段排：下午(2)视为晚于上午(1)
          va = (a.punishDate ? new Date(a.punishDate).getTime() : 0) * 10 + (a.punishPeriod === 2 ? 1 : 0)
          vb = (b.punishDate ? new Date(b.punishDate).getTime() : 0) * 10 + (b.punishPeriod === 2 ? 1 : 0)
        } else if (field === 'days') {
          va = a.days || 0
          vb = b.days || 0
        } else if (field === 'endDate') {
          va = a.endDate ? new Date(a.endDate).getTime() : 0
          vb = b.endDate ? new Date(b.endDate).getTime() : 0
        }
        return (va - vb) * dir
      })
      return rows
    },
    detailReduceRows() {
      const rows = (this.detail.reductions || []).slice()
      const { field, order } = this.lastReduceSort
      const dir = order === 'descending' ? -1 : 1
      rows.sort((a, b) => {
        if (field === 'createdAt') {
          const ta = a.createdAt || ''
          const tb = b.createdAt || ''
          return (ta < tb ? -1 : ta > tb ? 1 : 0) * dir
        }
        const va = field === 'reduceDays' ? (a.reduceDays || 0) : 0
        const vb = field === 'reduceDays' ? (b.reduceDays || 0) : 0
        return (va - vb) * dir
      })
      return rows
    }
  },
  mounted() {
    // 表格按住拖拽横向滚动（鼠标）：document 级委托，append-to-body 弹窗内也生效
    document.addEventListener('mousedown', this.onDragScrollStart)
    document.addEventListener('mousemove', this.onDragScrollMove)
    document.addEventListener('mouseup', this.onDragScrollEnd)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDragScrollStart)
    document.removeEventListener('mousemove', this.onDragScrollMove)
    document.removeEventListener('mouseup', this.onDragScrollEnd)
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this.loadConfig()
      this.loadList()
    },
    async loadConfig() {
      try {
        const res = await this.$http.get('/penalty/config')
        this.semesterStart = (res.data && res.data.semesterStartDate) || null
      } catch (e) {
        // 未设置或读取失败时降级为不带周标注
        this.semesterStart = null
      }
    },
    async loadList() {
      this.loading = true
      try {
        const res = await this.$http.get('/penalty/list', {
          params: { classId: this.classId, onlyPenalized: false }
        })
        this.allRows = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        this.$message.error('获取罚站列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSortChange({ column, prop, order }) {
      // 与移动端一致：取消排序时，按与上次相反的方向排序
      if (order === null) {
        order = this.lastSort.order === 'descending' ? 'ascending' : 'descending'
      }

      // 确保同一时刻只有一列处于排序状态
      if (this.$refs.penaltyTable) {
        const columns = this.$refs.penaltyTable.columns
        columns.forEach(col => {
          if (col.property !== prop) {
            col.order = null
          }
        })
        const currentColumn = columns.find(col => col.property === prop)
        if (currentColumn) {
          currentColumn.order = order
        }
      }

      this.lastSort = {
        field: prop,
        order: order
      }
    },
    handleDetailPenaltySort({ prop, order }) {
      if (order === null) {
        order = this.lastPenaltySort.order === 'descending' ? 'ascending' : 'descending'
      }
      this.applySingleColumnSort('detailPenaltyTable', prop, order)
      this.lastPenaltySort = {
        field: prop,
        order: order
      }
    },
    handleDetailReduceSort({ prop, order }) {
      if (order === null) {
        order = this.lastReduceSort.order === 'descending' ? 'ascending' : 'descending'
      }
      this.applySingleColumnSort('detailReduceTable', prop, order)
      this.lastReduceSort = {
        field: prop,
        order: order
      }
    },
    // 确保同一时刻只有一列处于排序状态
    applySingleColumnSort(tableRef, prop, order) {
      const table = this.$refs[tableRef]
      if (!table) return
      table.columns.forEach(col => {
        if (col.property !== prop) {
          col.order = null
        }
      })
      const current = table.columns.find(col => col.property === prop)
      if (current) {
        current.order = order
      }
    },
    penaltyRowClass({ row }) {
      if (row.status === '罚站中') {
        return 'pf-row-ongoing'
      }
      return 'pf-row-done'
    },
    openExemplaryDialog() {
      // 打开前刷新列表，保证"从未被罚站"数据最新
      this.loadList().then(() => {
        this.exemplaryDialogVisible = true
      })
    },
    async openDetailDialog(row) {
      this.detailTarget = {
        studentId: row.studentId,
        name: row.name
      }
      this.detail = {
        penaltyRecords: [],
        reductions: []
      }
      this.detailTab = 'penalty'
      this.lastPenaltySort = {
        field: 'punishDate',
        order: 'descending'
      }
      this.lastReduceSort = {
        field: 'createdAt',
        order: 'descending'
      }
      this.detailDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.detailPenaltyTable) {
          this.$refs.detailPenaltyTable.sort('punishDate', 'descending')
        }
        if (this.$refs.detailReduceTable) {
          this.$refs.detailReduceTable.sort('createdAt', 'descending')
        }
      })
      try {
        const res = await this.$http.get('/penalty/detail', {
          params: { classId: this.classId, studentId: row.studentId }
        })
        this.detail = {
          penaltyRecords: (res.data && res.data.penaltyRecords) || [],
          reductions: (res.data && res.data.reductions) || []
        }
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    /** 登记天数公式：有减罚时显示 3-1-1=1 形式 */
    daysFormula(row) {
      const list = (this.detail.reductions || []).filter(r => r.recordId === row.id)
      if (!list.length) return String(row.days)
      let expr = String(row.days)
      let sum = 0
      list.forEach(r => {
        expr += '-' + (r.reduceDays || 0)
        sum += r.reduceDays || 0
      })
      return expr + '=' + Math.max(row.days - sum, 0)
    },
    /** 减罚对象显示：对应罚站的处罚时间，无关联时显示"历史" */
    recordLabel(recordId) {
      if (!recordId) return '历史'
      const rec = (this.detail.penaltyRecords || []).find(p => p.id === recordId)
      if (!rec) return '历史'
      return this.fmtDateFull(rec.punishDate) + (rec.punishPeriod === 2 ? '下午' : '上午')
    },
    weekLabel(dateStr) {
      if (!this.semesterStart || !dateStr) return ''
      const start = new Date(this.semesterStart + 'T00:00:00')
      const d = new Date(dateStr + 'T00:00:00')
      if (isNaN(d.getTime()) || d < start) return ''
      const day = (d.getDay() + 6) % 7
      const startDay = (start.getDay() + 6) % 7
      const monday = new Date(start)
      monday.setDate(start.getDate() - startDay)
      const week = Math.floor((d.getTime() - monday.getTime()) / (7 * 86400000)) + 1
      // 格式：(第几周/周几)，周几用阿拉伯数字（周一=1 ... 周日=7）
      return '(' + week + '/' + (day + 1) + ')'
    },
    /** 日期显示：去年份 + 周标注，如 09-21(3/1) 表示第3周周一 */
    fmtDateFull(dateStr) {
      if (!dateStr) return '-'
      return String(dateStr).substring(5, 10) + this.weekLabel(String(dateStr).substring(0, 10))
    },
    onDragScrollStart(e) {
      if (e.button !== 0) return
      // 空白处按下时 target 是表格根元素（不在滚动容器内），所以先找最近的表格再取它的滚动容器
      const table = e.target.closest ? e.target.closest('.pf-drag-scroll') : null
      if (!table) return
      const wrapper = table.querySelector('.el-table__body-wrapper')
      if (!wrapper) return
      // 不在 mousedown 上 preventDefault（会破坏点击语义），防选中交给 pf-pc-dragging 的 user-select
      this._dragState = { wrapper, startX: e.clientX, startLeft: wrapper.scrollLeft, moved: false }
    },
    onDragScrollMove(e) {
      const s = this._dragState
      if (!s) return
      const dx = e.clientX - s.startX
      if (!s.moved && Math.abs(dx) > 5) {
        s.moved = true
        document.body.classList.add('pf-pc-dragging')
      }
      if (s.moved) {
        s.wrapper.scrollLeft = s.startLeft - dx
        e.preventDefault()
      }
    },
    onDragScrollEnd(e) {
      const s = this._dragState
      this._dragState = null
      document.body.classList.remove('pf-pc-dragging')
      if (s && s.moved && e.target) {
        // 拖动结束拦掉后续误触 click（不干扰未拖动时的按钮点击）
        const kill = (ev) => { ev.stopPropagation(); ev.preventDefault() }
        e.target.addEventListener('click', kill, { capture: true, once: true })
        setTimeout(() => e.target.removeEventListener('click', kill, { capture: true }), 120)
      }
    }
  }
}
</script>

<style>
/* 弹窗 append-to-body，样式必须非 scoped，统一用 pf-pc- 前缀避免污染 */

.pf-pc-dialog .el-dialog {
  border-radius: 12px;
}

.pf-pc-dialog .el-dialog__header {
  /* 青色 header（与移动端一致），!important 压过 body.xxx-theme 科目主题对弹窗头部的全局染色 */
  background: linear-gradient(90deg, #13b5a6, #3ec6b7) !important;
  padding: 13px 20px;
  border-bottom: none;
}

.pf-pc-dialog .el-dialog__title {
  color: #fff;
}

.pf-pc-title {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.pf-pc-title-text {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.pf-pc-subtitle {
  font-size: 12px;
  color: #d9fbf7;
}

.pf-pc-dialog .el-dialog__body {
  padding: 14px 20px 18px;
}

/* 叉按钮在 header 内上下居中（header 高约 54px，按钮高 30px → top 12px；
   全局默认 top 20px 是按原 header padding 20px 设计的，在紧凑 header 里会偏下） */
.pf-pc-dialog .el-dialog__headerbtn {
  top: 12px;
}

.pf-pc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.pf-pc-switch-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pf-pc-switch-label {
  font-size: 14px;
  color: #303133;
}

.pf-pc-exemplary-btn {
  color: #0f9488;
  border-color: #99e2da;
}

.pf-pc-exemplary-btn:hover,
.pf-pc-exemplary-btn:focus {
  color: #fff;
  background-color: #40e0d0;
  border-color: #40e0d0;
}

.pf-pc-table-card {
  border: 1px solid #a8e6de;
  border-radius: 10px;
  overflow: hidden;
}

.pf-pc-dialog .el-table.pf-drag-scroll {
  border: none;
  display: flex;
  flex-direction: column;
}

.pf-pc-dialog .el-table.pf-drag-scroll .el-table__body-wrapper {
  flex: 1;
}

.pf-pc-dialog .el-table {
  font-size: 14px;
}

/* 行背景：罚站中浅橙、已站完浅绿，hover 不变色 */
.pf-pc-dialog .el-table .pf-row-ongoing td,
.pf-pc-dialog .el-table tr.pf-row-ongoing:hover td {
  background-color: #fdf6ec !important;
}

.pf-pc-dialog .el-table .pf-row-done td,
.pf-pc-dialog .el-table tr.pf-row-done:hover td {
  background-color: #f0f9eb !important;
}

/* 点击行背景色完全不变（压制 Element UI 默认 hover 高亮） */
.pf-pc-dialog .el-table tbody tr:hover > td {
  background-color: transparent !important;
}

.pf-pc-dialog .el-table .pf-row-ongoing:hover > td,
.pf-pc-dialog .el-table .pf-row-done:hover > td {
  background-color: #fdf6ec !important;
}

.pf-pc-dialog .el-table .pf-row-done:hover > td {
  background-color: #f0f9eb !important;
}

.pf-pc-action-btn {
  padding: 0;
  margin: 0;
  color: #0f9488;
  font-size: 14px;
}

/* 详情两表同款边框与贴底滚动条 */
.pf-pc-dialog .el-table.pf-pc-detail-table {
  min-height: 320px !important;
  border: 1px solid #a8e6de;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pf-pc-dialog .el-table.pf-pc-detail-table .el-table__body-wrapper {
  flex: 1;
}

.pf-pc-dialog .el-table .el-table__header-wrapper th {
  background-color: #e8f7f5;
}

.pf-pc-footer {
  text-align: right;
}

/* 守纪标兵弹窗 */
.pf-pc-exemplary-banner {
  background: linear-gradient(135deg, #40e0d0 0%, #2bb3a3 100%);
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 12px;
  text-align: center;
}

.pf-pc-banner-icon {
  font-size: 30px;
  color: #fff;
}

.pf-pc-banner-title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin: 4px 0 6px;
}

.pf-pc-banner-text {
  font-size: 13px;
  color: #eafffb;
}

.pf-pc-banner-left {
  text-align: left;
}

.pf-pc-banner-right {
  text-align: right;
}

.pf-pc-exemplary-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #a8e6de;
  border-radius: 8px;
}

.pf-pc-exemplary-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  border-bottom: 1px solid #e4f5f2;
  font-size: 14px;
}

.pf-pc-exemplary-row:last-child {
  border-bottom: none;
}

.pf-pc-exemplary-no {
  color: #0f9488;
  font-weight: bold;
  min-width: 36px;
}

.pf-pc-exemplary-name {
  color: #303133;
  flex: 1;
}

.pf-pc-exemplary-check {
  color: #40e0d0;
  font-weight: bold;
}

.pf-pc-exemplary-empty {
  padding: 24px 0;
  text-align: center;
  color: #909399;
  font-size: 14px;
  border: 1px solid #a8e6de;
  border-radius: 8px;
}

.pf-pc-exemplary-footer {
  margin-top: 12px;
  text-align: center;
  color: #0f9488;
  font-size: 13px;
}

/* 拖拽时禁止选中文字 */
body.pf-pc-dragging {
  user-select: none;
  cursor: grabbing;
}

body.pf-pc-dragging * {
  cursor: grabbing !important;
}
</style>
